import * as R from 'ramda';
import getDefaults from 'json-schema-defaults';
import { isObject } from './common';
export function createSchema(schema) {
    return {
        type: 'object',
        properties: schema,
    };
}
// 每个组件右侧面板默认的公共配置,为formily内容
export var commonDataForm = {
    visible: {
        title: '显隐',
        type: 'boolean',
        default: true,
        description: '若为表达式，仅false时隐藏',
        'x-component': 'SwitchToggleExpression',
    },
    classNames: {
        title: '样式名',
        type: 'array',
        default: [],
        'x-component': 'ArrayTableToggleExpression',
        'x-component-props': {
            renderMoveDown: function () { return null; },
            renderMoveUp: function () { return null; },
            operationsWidth: 40,
            operations: {
                title: '操作',
            },
            draggable: true,
            dialog: true,
        },
        items: {
            type: 'object',
            properties: {
                name: {
                    type: 'string',
                    title: '样式名',
                },
                isApply: {
                    type: 'string',
                    title: '是否应用',
                    default: true,
                    'x-component': 'SwitchToggleExpression',
                    description: '控制该类名是否被应用',
                },
            },
        },
    },
};
/** 获取右侧工具栏面板公共配置默认值 */
export var defaultCommonData = getDefaults(createSchema(commonDataForm));
/** 获取enableCommonData的默认值 */
export function getDefaultCommonData(dataGroup) {
    if (!dataGroup) {
        return {};
    }
    if (dataGroup === '*') {
        return defaultCommonData;
    }
    var data = {};
    R.mapObjIndexed(function (value, key) {
        // 这类默认值为布尔值的配置，要自定义默认值优先级高于内置默认值；防止内置为false优先级想设置为true的情况
        if (key === 'visible') {
            if (typeof value === 'boolean') {
                data[key] = value;
            }
            return;
        }
        // 当该属性为true，则默认开启该配置
        if (typeof value === 'boolean' && value) {
            data[key] = defaultCommonData[key];
            return;
        }
        if (key === 'classNames' && Array.isArray(value)) {
            var tempClassNames_1 = [];
            value.forEach(function (className) {
                if (!isObject(className)) {
                    return;
                }
                var name = className.name, isApply = className.isApply;
                if (!name) {
                    return;
                }
                tempClassNames_1.push({
                    name: name,
                    isApply: typeof isApply === 'boolean' ? isApply : true,
                });
            });
            data[key] = tempClassNames_1;
        }
    }, dataGroup);
    return data;
}
//# sourceMappingURL=data.js.map